// extracted by mini-css-extract-plugin
module.exports =  {"arrow":"SO6Hte","left":"qQmugS","right":"VM7Je0","chevron":"W8YhG2"};